<template>
    <base-button
        :is-disabled="isDisabled"
        :class="appliedVariant"
        class="rounded-sm font-bold"
    >
        <slot />
    </base-button>
</template>

<script>
    import BaseButton from './BaseButton.vue';

    export default {
        components: {
            BaseButton,
        },

        props: {
            variant: {
                type: String,
                default: 'primary',
            },

            isDisabled: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                variants: {
                    primary: 'bg-black text-white',
                    primaryDisabled: 'bg-gray-light text-black',
                    secondary: 'border border-gray bg-white',
                },
            };
        },

        computed: {
            appliedVariant() {
                return this.variant === 'primary' && this.isDisabled === true ? this.variants.primaryDisabled : this.variants[this.variant];
            },
        },
    };
</script>
